import React, { useContext } from "react";
//Styles
//import { ThemeProvider } from "styled-components";
import { ThemeProvider, Theme, ThemeContrast } from "@uaveiro/ui";

//import Theme from "./services/theme.semantic";
//import ThemeContrast from "./services/theme.highContrast";
//Context
import { StoreContext } from "./context/StoreContext";

function ThemeRegister({ children }) {
  const { state } = useContext(StoreContext);
  return (
    <ThemeProvider
      theme={Number(state.accessibilityValue) === 0 ? Theme : ThemeContrast}
    >
      {children}
    </ThemeProvider>
  );
}

export default ThemeRegister;
